import { render, staticRenderFns } from "./searchSafetyForms.vue?vue&type=template&id=46750498&scoped=true"
import script from "./searchSafetyForms.vue?vue&type=script&lang=js"
export * from "./searchSafetyForms.vue?vue&type=script&lang=js"
import style0 from "./searchSafetyForms.vue?vue&type=style&index=0&id=46750498&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46750498",
  null
  
)

export default component.exports